import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const SuccessNow = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const isProcessing = useRef(false);

  useEffect(() => {
    if (isProcessing.current) return;

    const paymentKey = searchParams.get('paymentKey');
    const orderId = searchParams.get('orderId');
    const amount = searchParams.get('amount');
    const db_order_id = searchParams.get('order_id');

    const reserve_yn = searchParams.get('reserve_yn') || 'N';
    const pickup_date = searchParams.get('pickup_date') || '';
    const pickup_time = searchParams.get('pickup_time') || '';
    const pickup_datetime = searchParams.get('pickup_datetime') || '';

    if (!paymentKey || !orderId || !amount || !db_order_id) {
      console.error("필수 파라미터 누락", {
        paymentKey,
        orderId,
        amount,
        db_order_id
      });
      alert("결제 승인에 필요한 정보가 없습니다.");
      navigate('/');
      return;
    }

    isProcessing.current = true;

    axios.post('/api/pay/success/now', {
      paymentKey,
      orderId,
      amount,
      order_id: db_order_id,
      reserve_yn,
      pickup_date,
      pickup_time,
      pickup_datetime
    })
    .then((res) => {
      console.log("즉시구매 승인 성공:", res.data);
      setData(res.data);
      setLoading(false);
    })
    .catch((err) => {
      console.error("즉시구매 승인 실패:", err.response?.data || err.message);

      const errMsg =
        err.response?.data?.message ||
        "결제 승인 중 오류가 발생했습니다.";

      alert(errMsg);
      setLoading(false);
      navigate('/');
    });
  }, [searchParams, navigate]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 20px' }}>
        <div className="spinner-border text-primary" role="status"></div>
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <div style={{ fontWeight: '700', fontSize: '16px' }}>
            결제 승인 완료 중입니다...
          </div>

          <div
            style={{
              marginTop: '8px',
              fontSize: '14px',
              color: '#666'
            }}
          >
            잠시만 기다려주세요.
          </div>
        </div>
      </div>
    );
  }

  const orderIdForView = data?.new_order_id || data?.order_id || '';
  const amountForView =
    Number(data?.responseJson?.totalAmount || searchParams.get('amount') || 0);

  return (
    <div className="container" style={styles.container}>
      <h2 style={styles.title}>주문내역</h2>

      <div style={styles.card}>
        <div style={styles.header}>
          <div>
            <div style={styles.orderNumber}>
              주문번호: {orderIdForView}
            </div>
          </div>
        </div>

        <div style={styles.SuccessNotice}>주문이 완료되었습니다</div>

        <table style={styles.table}>
          <tbody>
            <tr>
              <th style={styles.th}>결제금액</th>
              <td style={styles.td}>
                {amountForView.toLocaleString()}원
              </td>
            </tr>

            <tr>
              <th style={styles.th}>주문상태</th>
              <td style={styles.td}>
                <span
                  role="button"
                  onClick={() => navigate(`/order/detail?order_id=${orderIdForView}`)}
                  style={{
                    color: '#6c757d',
                    cursor: 'pointer',
                    fontWeight: '500'
                  }}
                >
                  주문상세 보기
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

const styles = {
  container: { width: '100%', maxWidth: '600px', margin: '0 auto', padding: '0 0 40px' },
  title: { fontSize: '1.1rem', marginLeft: '20px', marginTop: '20px' },
  linkBack: { textDecoration: 'none', color: '#000' },
  card: { background: '#fff', marginTop: '20px', padding: '20px', borderRadius: '1px', boxShadow: '0 2px 6px rgba(0,0,0,0.05)' },
  header: { display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' },
  orderNumber: { fontWeight: 'bold', fontSize: '1.1rem' },
  orderDate: { fontSize: '0.8rem', color: '#888' },
  SuccessNotice: { color: '#0d6efd', fontWeight: 'bold', textAlign: 'center', margin: '30px 0', fontSize: '16px' },
  deliverySteps: { display: 'flex', justifyContent: 'space-between', margin: '30px 0 20px', position: 'relative' },
  step: { textAlign: 'center', flex: 1, position: 'relative', color: '#ddd' },
  activeStep: { color: '#00704a' },
  circle: { width: '26px', height: '26px', borderRadius: '50%', background: '#ddd', color: '#fff', fontSize: '13px', fontWeight: 'bold', lineHeight: '26px', margin: '0 auto 5px', position: 'relative', zIndex: 1 },
  activeCircle: { background: '#00704a' },
  stepLine: { position: 'absolute', top: '13px', left: '50%', width: '100%', height: '2px', background: '#ddd', zIndex: 0 },
  activeLine: { background: '#00704a' },
  table: { width: '100%', borderCollapse: 'collapse', marginBottom: '25px', fontSize: '14px' },
  th: { width: '25%', textAlign: 'left', padding: '10px 0', borderBottom: '1px solid #eee', whiteSpace: 'nowrap' },
  td: { textAlign: 'left', padding: '10px 0', borderBottom: '1px solid #eee' },
  flexBetween: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  subBtn: { padding: '4px 8px', fontSize: '12px', borderRadius: '2px', border: '1px solid #ddd', background: '#fff', cursor: 'pointer' },
  productList: { borderTop: '1px solid #eee', paddingTop: '12px' },
  productItem: { display: 'flex', marginBottom: '14px', alignItems: 'center' },
  productThumb: { width: '64px', height: '64px', borderRadius: '5px', overflow: 'hidden', marginRight: '12px', border: '1px solid #ddd', flexShrink: 0 },
  thumbImg: { width: '100%', height: '100%', objectFit: 'cover' },
  productInfo: { flexGrow: 1 },
  productName: { fontWeight: 'bold', fontSize: '14px', marginBottom: '4px' },
  productQty: { color: '#666', fontSize: '13px' },
  productPrice: { color: '#666', fontSize: '13px' },
  itemActions: { display: 'flex', gap: '5px' }
};

export default SuccessNow;